export default function (obj, advices) {
  if (!advices || !(typeof advices === 'object' || Array.isArray(advices))) {
    throw new Error('wrong type of advices');
  }
  if (typeof obj === 'function') {
    return proxyFunction(obj, toArray(advices));
  }
  if (typeof obj !== 'object') {
    throw new Error('wrong type of obj');
  }
  return proxyObject(obj, advices);
}

function toArray(data) {
  return Array.isArray(data) ? data : [data];
}

function proxyFunction(originFunc, advices) {
  var func = originFunc;
  for (var advice of advices) {
    func = advice(func);
  }
  return func;
}

function proxyObject(obj, advices) {
  var nameArr = getProxiedFunctionName(obj, advices);
  var isArray = Array.isArray(advices);
  var proxied = {};
  for (var name of nameArr) {
    var adviceArr = isArray ? advices : toArray(advices[name]);
    var func = obj[name].bind(obj);
    for (var advice of adviceArr) {
      func = advice(obj, func);
    }
    proxied[name] = func;
  }
  return proxied;
}

function getProxiedFunctionName(obj, advices) {
  var isArray = Array.isArray(advices);
  var res = [];
  for (var name in obj) {
    var func = obj[name];
    if (typeof func != 'function') {
      continue;
    }
    if (isArray || advices[name]) {
      res.push(name);
    }
  }
  return res;
}